import { useTranslation } from "react-i18next";

function WhatWeBring() {
  const { t: translate } = useTranslation();

  return (
    <section id="what-we-bring" className="about what-we-bring">
      <div className="row about__row">
        <div className="about__text what-we-bring__text" data-aos="fade-up">
          <h2 className="section__title">{translate("whatWeBring.title")}</h2>
          <div className="section__divider"></div>
          <p className="about__highlight">{translate("whatWeBring.paragraph1")}</p>
          <p className="about__highlight">{translate("whatWeBring.paragraph2")}</p>
          <p className="about__highlight">{translate("whatWeBring.paragraph3")}</p>
          <p className="about__highlight">{translate("whatWeBring.paragraph4")}</p>
        </div>
      </div>
    </section>
  );
}

export default WhatWeBring;
